import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { Suspense, lazy, useEffect } from "react";
import { AuthProvider } from "hooks/useAuth";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CustomLoader } from "components/common";
import { RecoilRoot } from "recoil";
import { theme } from "theme/theme";
import { ThemeProvider } from "@mui/material";
import ClientSession from "components/pages/client-session/ClientSession";
import Clarity from "@microsoft/clarity";

const RoutesComponent = lazy(() => import("routes"));

function App() {
  useEffect(() => {
    Clarity.init("l0o7x9v63s");
  }, []);

  return (
    <>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <RecoilRoot>
            <AuthProvider>
              <Suspense fallback={<CustomLoader />}>
                <ClientSession />
                <RoutesComponent />
              </Suspense>
            </AuthProvider>
          </RecoilRoot>
        </ThemeProvider>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
